import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Button, Container } from 'react-bootstrap'
import { GetCollection } from '../../../../firebase/firebase'

export const BlogPostList = (props) => {
    const [posts, setPosts] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (loading) {
            GetCollection('blogPosts', false).then((data) => {
                setPosts(data.docs.map(doc => doc.data()))
            })
        }
    }, [])

    return (
        <>
            <Container fluid>
                <Row>
                    {posts && posts.map((post, i) => {
                        return (
                            <BlogPostCard post={post} key={i} />
                        )
                    })}
                </Row>
            </Container>
        </>
    )
}

const BlogPostCard = (props) => {
    const post = props.post
    return (
        <>
            {post.text &&
                <Col sm={12} md={6} lg={3} className='p-4'>
                    <Card className='h-100'>
                        <Card.Img variant="top" src={post.image} style={{ height: '275px', width: 'auto' }} />
                        <Card.Body>
                            <Card.Title>
                                {post.title}
                            </Card.Title>
                            <Card.Subtitle className='text-muted my-2'>
                                by {post.creator} on {new Date(post.time).toDateString()}
                            </Card.Subtitle>
                            <Card.Text>
                                {post.text.substring(0, 150)}...
                            </Card.Text>
                            <Card.Footer>
                                <Button href={`/blog/${post.id}`}>
                                    View
                                </Button>

                            </Card.Footer>
                        </Card.Body>
                    </Card>
                </Col>
            }
        </>
    )
}

